import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import AdminUsers from "./AdminUsers";
import AdminUsersTransactions from "./AdminUsersTransactions";
import AdminComments from "./AdminComments";
import { useAdminSession } from "../context/AdminSessionContext";
import { hasPermission } from "../utils/permissionHelpers";
import WorkspaceShell from "../Components/ui/WorkspaceShell";
import InfoMarkerHint from "../Components/ui/InfoMarkerHint";

type UsersTabKey = "users" | "transactions" | "comments";

export default function AdminWorkspaceUsers() {
  const [params, setParams] = useSearchParams();
  const { session } = useAdminSession();
  const permissions = useMemo(() => session?.permissions ?? [], [session?.permissions]);

  const tabs = useMemo(
    () =>
      [
        { key: "users", label: "User 360", allow: hasPermission(permissions, "Users.View"), render: <AdminUsers /> },
        {
          key: "transactions",
          label: "Purchases & Tokens",
          allow: hasPermission(permissions, "Users.View"),
          render: <AdminUsersTransactions />,
        },
        { key: "comments", label: "Comments", allow: hasPermission(permissions, "Comments.View"), render: <AdminComments /> },
      ] as const,
    [permissions],
  );

  const available = tabs.filter((tab) => tab.allow);
  const requested = (params.get("tab") ?? "users") as UsersTabKey;
  const active = available.find((tab) => tab.key === requested) ?? available[0];

  if (!active) {
    return <div className="admin-soft-alert text-sm">Bu workspace icin yetkin bulunmuyor.</div>;
  }

  const setTab = (key: string) => {
    const next = new URLSearchParams(params);
    next.set("tab", key);
    setParams(next, { replace: true });
  };

  return (
    <WorkspaceShell
      title="User 360"
      subtitle="Kullanici profilleri, yetki degisiklikleri, paket/token gecmisi ve yorum moderasyonu tek panelde."
      tabs={available.map((tab) => ({ key: tab.key, label: tab.label }))}
      activeKey={active.key}
      onTabChange={setTab}
      statPills={
        <>
          <span className="admin-pill">Delete impact</span>
          <span className="admin-pill">Gift operasyonlari</span>
          <span className="admin-pill">Audit timeline</span>
          <span className="admin-pill inline-flex items-center gap-1">
            Moderasyon
            <InfoMarkerHint markerKey="profile.social" />
          </span>
        </>
      }
    >
      {active.render}
    </WorkspaceShell>
  );
}
